module.exports = __webpack_public_path__ + "media/images/xpass/class-loader-2-a9659aca269791237b0ac14afd28d033.svg";